const newLocal = 'LOADING_START'
const newLocal2 = 'LOADING_END'
export default (state =[], action) => {
    switch (action.type) {
      case newLocal:
          return true
      case newLocal2:
          return false
      default:
          return state
    }
  }